var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('products-reviews-table',{staticClass:"mb-4",attrs:{"table-data":_vm.reviews,"fields":_vm.fields,"loading":_vm.loading},on:{"updateReviews":_vm.fetchReviews}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }